import React from 'react';
import { X } from 'lucide-react';
import CreateMilestoneForm from './milestones/CreateMilestoneForm';
import type { MilestoneType, MilestoneStatus } from './milestones/CreateMilestoneForm';

type CreateMilestoneModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (
    title: string,
    description: string | null,
    status: MilestoneStatus,
    targetDate: string | null,
    type?: MilestoneType,
    wordCount?: number | null,
    betaReaderCount?: number | null,
    researchTopics?: string[] | null,
    worldbuildingAspects?: string[] | null,
    characterNames?: string[] | null,
    outlineChapters?: number | null
  ) => Promise<void>;
};

export default function CreateMilestoneModal({
  isOpen,
  onClose,
  onSubmit
}: CreateMilestoneModalProps) {
  if (!isOpen) return null;

  const handleSubmit = async (data: {
    title: string;
    description: string | null;
    type: MilestoneType;
    status: MilestoneStatus;
    targetDate: string | null;
    wordCount?: number | null;
    betaReaderCount?: number | null;
    researchTopics?: string[] | null;
    worldbuildingAspects?: string[] | null;
    characterNames?: string[] | null;
    outlineChapters?: number | null;
  }) => {
    await onSubmit(
      data.title,
      data.description,
      data.status,
      data.targetDate,
      data.type,
      data.wordCount,
      data.betaReaderCount,
      data.researchTopics,
      data.worldbuildingAspects,
      data.characterNames,
      data.outlineChapters
    );
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose} />
        <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full">
          <div className="flex items-center justify-between border-b px-6 py-4">
            <h2 className="text-xl font-bold">Add Milestone</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="p-6">
            <CreateMilestoneForm
              onSubmit={handleSubmit}
              onCancel={onClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
}